import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useGetHistoryMoves } from 'modules/Room/Hooks/useGetHistoryMoves';

import HistoryMove from './HistoryMove';
import './HistoryMoves.scss';

const HistoryMoves = () => {
  const { t } = useTranslation();

  const gameHistory = useGetHistoryMoves();

  const { activeRoomId } = useParams();
  const historyContainerRef = useRef<HTMLDivElement>(null);
  const prevHistoryLengthRef = useRef(gameHistory.length);

  useEffect(() => {
    if (gameHistory.length !== prevHistoryLengthRef.current) {
      if (historyContainerRef.current) {
        historyContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
      }
      prevHistoryLengthRef.current = gameHistory.length;
    }
  }, [gameHistory.length]);

  return (
    <div className="flex flex-1 flex-col items-center">
      <h4 className="font-xl mb-1 font-medium text-blue-text">{t('common.history')}</h4>

      <div className="relative w-full overflow-hidden rounded-[7px] border border-dark-border bg-dark-blue">
        <div
          style={{ background: 'rgba(255, 255, 255, 0.03)' }}
          className="mb-[10px] flex w-full rounded-t-[7px] py-[10px] text-[14px] font-light uppercase text-gray"
        >
          <span className="flex w-[33%] justify-center">{t('common.you')}</span>
          <span className="flex w-[33%] justify-center">{t('common.round')}</span>
          <span className="flex w-[33%] justify-center">{t('common.opponent')}</span>
        </div>
        <div ref={historyContainerRef} className="history h-[344px] overflow-auto">
          {activeRoomId &&
            gameHistory.map((round, index) => (
              <HistoryMove
                key={`${round.encrMoveA}_${index}`}
                round={round}
                gameCount={gameHistory.length - index}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default HistoryMoves;
